"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnnotationLocationNodeId = exports.getAnnotationLocationCoordinates = exports.getHasAnnotationLocation = void 0;

var _reselect = require("reselect");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var getAnnotationLocation = function getAnnotationLocation(state) {
  return (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.annotationLocation")) || {};
};
/**
 * Function to return a derived state of having an annotation location
 * @returns {boolean} indication if an annotation location is present
 */


var getHasAnnotationLocation = (0, _reselect.createSelector)([getAnnotationLocation], function (annotationLocation) {
  return !!annotationLocation.coordinates;
});
/**
 * Function to return a derived state of annotation location coordinates
 * @returns {object} coordinates data associated with the current annotation location
 */

exports.getHasAnnotationLocation = getHasAnnotationLocation;
var getAnnotationLocationCoordinates = (0, _reselect.createSelector)([getAnnotationLocation], function (annotationLocation) {
  return annotationLocation && annotationLocation.coordinates;
});
/**
 * Function to return a derived state of annotation location nodeId
 * @returns {string} node ID associated with the current annotation location
 */

exports.getAnnotationLocationCoordinates = getAnnotationLocationCoordinates;
var getAnnotationLocationNodeId = (0, _reselect.createSelector)([getAnnotationLocation], function (annotationLocation) {
  return annotationLocation && annotationLocation.nodeId;
});
exports.getAnnotationLocationNodeId = getAnnotationLocationNodeId;